export const STRIPE_PUBLIC_KEY = 'pk_live_51QSHnGLl0kIW1sySRlKJfp2tB3ykp9w93E6YLURFEiJLu8gPzaICv98xYvaaEitgXHByAWdKRR2HpHwYB3DD0Jlz00HQstfM5u';

export const getPlanDetails = (planId) => {
 const plans = {
    // basic: {
    //   id: 'basic',
    //   name: 'Basique',
    //   price: '0',
    //   priceId: 'prod_RLhaHQyQyeMCto',
    //   description: 'Parfait pour commencer'
    // },
    pro: {
      id: 'pro',
      name: 'Pro',
      price: '19.90',
      priceId: 'prod_T9cd08zVJ5laxw', 
      description: 'Pour les utilisateurs actifs'
    },
    'pro-annual': {
      id: 'pro-annual',
      name: 'Pro Annual',
      price: '199', 
      priceId: 'prod_T9cdtvO5JzDFAI', 
      description: 'Pro - Abonnement annuel'
    },
    premium: {
      id: 'premium',
      name: 'Premium',
      price: '69.90',
      priceId: 'prod_T9ceuCdQqAQ306',
      description: 'Expérience complète'
    },
    'premium-annual': {
      id: 'premium-annual',
      name: 'Premium Annual',
      price: '749', 
      priceId: 'prod_T9cc02TtMZe4ye', 
      description: 'Premium - Abonnement annuel'
    }
  };
  
  return plans[planId] || null;
};

